module.exports = __webpack_public_path__ + "img/careers_creativity.1bf60203.png";